import React from 'react';
import localize from '../localize';
import './StatsTable.css';
import classNames from 'classnames';

export default localize()(({ i18n, ethernetStats, wirelessStats, headerText, showGames=false, showScores=false, showTypeLabels=true }) => {
	const echo = (n) => n;
  const classes = classNames({ 'show-games': showGames, 'show-scores': showScores });

  let rows = [
    { key: 'connection_score', format: echo },
    { key: 'latency', format: i18n.ms },
    { key: 'packet_loss', format: i18n.fractionalPercent },
    { key: 'jitter', format: i18n.ms },
    { key: 'player_games', format: echo }
  ];

  if(!showGames) {
  	rows = rows.slice(0, -1);
  }

  if(!showScores) {
    rows = rows.slice(1);
  }

  rows = rows.map(({ key, format }) => (
    <tr key={key}>
      <td>{i18n.t('metrics.' + key, false)}:</td>
      { ethernetStats && <td>{ ethernetStats.player_games > 0 ? format(ethernetStats[key]) : '-' }</td> }
      { wirelessStats && <td>{ wirelessStats.player_games > 0 ? format(wirelessStats[key]) : '-' }</td> }
    </tr>
  ));

  return (
   <table className={`stats-table ${classes}`}>
      { showTypeLabels && 
        <thead>
        <tr>
          <th></th>
          { ethernetStats && <th>{i18n.t('metrics.ethernet')}</th> }
          { wirelessStats && <th>{i18n.t('metrics.wifi')}</th> }
        </tr>
      </thead> }
      <tbody>
        { headerText && <tr>
          <td colSpan="2">{ headerText }</td>
        </tr> }
        {rows}
      </tbody>
    </table>);
});



// WEBPACK FOOTER //
// ./src/components/StatsTable/index.js